import styled from 'styled-components';
import { colors } from '../../../styles/colors';

export const Styles = styled.div`
  margin-bottom: 30px;
  position: relative;
  @media screen and (max-width: 1200px) {
    margin-bottom: 50px;
  }
  div.instructor-img {
    max-width: 255px;
    aspect-ratio: 255 / 261;
    display: inline-block;
    position: relative;

    img {
      width: 100%;
      border-radius: 5px;
    }
    @media screen and (max-width: 1200px) {
      width: 170px;
      height: 180px;
    }
    @media screen and (max-width: 991px) {
      display: block;
      margin-bottom: 6px;
    }
  }
  div.instructor-box {
    position: absolute;
    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.08);
    padding: 25px;
    background: #ffffff;
    border-radius: 5px;
    width: calc(100% - 240px);
    left: 240px;
    top: 20px;
    @media screen and (max-width: 1200px) {
      display: inline-block;
      width: calc(100% - 140px);
      left: 145px;
      top: 5px;
    }
    @media screen and (max-width: 991px) {
      position: static;
      display: inline-block;
      width: 100%;
      transform: translateX(0);
    }
    .top-content {
      margin-bottom: 20px;

      .instructor-name {
        h6 {
          color: ${colors.black2};
          font-weight: 600;
          text-transform: uppercase;
          margin-bottom: 12px;

          @media (max-width: 575px) {
            font-size: 14px;
          }
        }
        p {
          font-size: 14px;
          color: ${colors.text3};
          font-weight: 500;
        }
      }
    }
  }

  .instructor-desk {
    p {
      font-size: 15px;
      color: ${colors.text2};
      line-height: 25px;

      @media (max-width: 575px) {
        font-size: 14px;
      }
    }
  }
`;
